"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatDate_1 = __importDefault(require("../../utils/formatDate"));
function formatPost(data, mappers) {
    const posts = [];
    if (data?.posts) {
        for (const p of data.posts) {
            if (typeof p === 'number')
                continue;
            const thumb = p?.teaser?.thumbnail;
            let mappedThumbnail = null;
            let author = '';
            if (typeof p?.author === 'object' && p?.author?.fullName) {
                author = p.author.fullName;
            }
            mappedThumbnail = mappers.mapBlock({
                block: {
                    blockType: 'image',
                    mediaReference: thumb,
                },
                mappers,
            });
            posts.push({
                title: p.teaser?.title &&
                    mappers.mapRichText({ richText: p.teaser.title, mappers }),
                thumbnail: mappedThumbnail,
                author: author,
                date: (0, formatDate_1.default)({ date: p.teaser.date }),
                link: p.pagePath,
            });
        }
    }
    if (!posts.length) {
        return null;
    }
    return {
        title: data?.title,
        posts,
    };
}
function mapToResourcesProps({ data, mappers, inHero }) {
    return {
        top: formatPost(data.top, mappers),
        left: formatPost(data.left, mappers),
        right: formatPost(data.right, mappers),
        id: data?.id,
    };
}
exports.default = mapToResourcesProps;
